// extracted by mini-css-extract-plugin
export default {"root":"Ogu0cvqhmC1boQHpkQjY","wrap":"VRGnDFPulqlpKrAOsKLR"};